import { roles } from '../configs/usersConfig'
import useUserPermission from './useUserPermission'

export const useAllowedRoles = () => {
  const { allowedRoles: myAllowedRoles } = useUserPermission('user')
  return roles.filter(rol => myAllowedRoles.includes(rol.code))
}
